import { createReducer } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import t from '@/store/types';

interface ResourcesState {
  data: { resources: Record<string, any> };
  fields: Record<string, any>;
  columns: Record<string, any>;
  resourceFields: Record<string, any>;
  resourceColumns: Record<string, any>;
  metadata: Record<string, { label: string; baseRoute: string }>;
}

const initialState: ResourcesState = {
  data: {
    resources: {},
  },
  fields: {},
  columns: {},
  resourceFields: {},
  resourceColumns: {},

  metadata: {
    accounts: {
      label: 'Accounts',
      baseRoute: '/comptabilite/plan-comptable',
    },
    items: {
      label: 'Items',
      baseRoute: '/stock/articles',
    },
    manual_journals: {
      label: 'Journals',
      baseRoute: '/comptabilite/ecritures',
    },
  },
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.RESOURCE_COLUMNS_SET, (state, action: AnyAction) => {
    const _columns: Record<string, any> = {};

    action.columns.forEach((column: any) => {
      _columns[column.id] = column;
    });
    state.columns = {
      ...state.columns,
      ..._columns,
    };
    state.resourceColumns[action.resource_slug] = action.columns.map(
      (c: any) => c.id,
    );
  });

  builder.addCase(t.RESOURCE_FIELDS_SET, (state, action: AnyAction) => {
    const _fields: Record<string, any> = {};

    action.fields.forEach((field: any) => {
      _fields[field.key] = field;
    });
    state.fields = {
      ...state.fields,
      ..._fields,
    };
    state.resourceFields[action.resource_slug] = action.fields.map(
      (f: any) => f.key,
    );
  });

  builder.addCase(t.RESOURCE_DATA_SET, (state, action: AnyAction) => {
    const { data, resourceKey } = action.payload;
    const _data: Record<string, any> = {};

    data.forEach((item: any) => {
      _data[item.id] = item;
    });
    const order = data.map((item: any) => item.id);

    state.data.resources[resourceKey] = {
      ...(state.data.resources[resourceKey] || {}),
      data: _data,
      order,
    };
  });
});
